import React from 'react';
import { IndexRedirect, IndexRoute, Route } from 'react-router';

import ResultsDataProvider from 'chameleon-src/components/results/ResultsDataProvider';
import TeacherStudentResultsContainer from 'chameleon-src/components/results/TeacherStudentResultsContainer';
import ResultsContainer from 'chameleon-src/components/results/ResultsContainer';
import PermissionsContainer from 'legacy-src/components/auth/PermissionsContainer';
import QuestionsTable from 'chameleon-src/components/results/resultsQuestions';
import AssignmentResources from 'legacy-src/components/assignment/AssignmentResources';
import AssignmentTrendReport from 'chameleon-src/components/TrendReportingContainer/AssignmentTrendReport';
import StudentPerformanceOverview from 'legacy-src/components/assessment/Results/StudentPerformanceOverview';
import SummaryReportContainer from 'legacy-src/components/assessment/Results/SummaryReport/SummaryReportContainer/SummaryReportContainer';
import TeacherPerformanceItem from 'legacy-src/components/assessment/Results/PerformanceItem/TeacherWrapper';
import TeacherStudentResponses from 'legacy-src/components/assessment/Results/StudentResponses/TeacherContainer';
import SingleStudentPerformanceOverview from 'legacy-src/components/assessment/Results/SingleStudentPerformanceOverview';
import StudentPerformanceItem from 'legacy-src/components/assessment/Results/PerformanceItem/StudentWrapper';
import SingleStudentResources from 'legacy-src/components/assessment/Results/SingleStudentResources';
import SingleStudentQuestions from 'legacy-src/components/assessment/Results/SingleStudentQuestions';
import ScoringLayout from 'legacy-src/components/scoring/ScoringLayout';
import StudentResponses from 'legacy-src/components/assessment/Results/StudentResponses/StudentContainer';
import ValidatedRoute from 'chameleon-src/utility/validatedRoute';

const studentResultsPages = (
  <Route name="StudentResults" path="performance" leftNav={false}>
    <IndexRoute component={SingleStudentPerformanceOverview} leftNav={false} />

    <Route
      name="StudentResponses"
      path="responses"
      component={StudentResponses}
      leftNav={false}
    >
      <Route
        name="SingleStudentRubricsQuestions"
        path="questions/:questionId(/parts/:partId)"
        component={ScoringLayout}
        leftNav={false}
      />
    </Route>

    <Route
      name="SingleStudentPerformanceItem"
      path=":questionId"
      component={StudentPerformanceItem}
      leftNav={false}
    >
      <Route
        name="SingleStudentPerformanceItemPart"
        path="parts/:partId"
        component={StudentPerformanceItem}
        leftNav={false}
      />
      <Route name="submissionResultsView" path="review" leftNav={false} />
    </Route>
  </Route>
);

export default (
  <Route
    name="results"
    path="assessments/results/:assignmentId"
    component={PermissionsContainer(ValidatedRoute(ResultsDataProvider))}
    leftNav={false}
  >
    <Route component={ResultsContainer}>
      <IndexRedirect to="resources" />
      {studentResultsPages}
      <Route
        name="summary-report"
        path="summary-report"
        leftNav={false}
        component={SummaryReportContainer}
      />
      <Route
        name="csperformance-summary"
        path="csperformance"
        leftNav={false}
        component={AssignmentTrendReport}
      />
      <Route
        name="results-summary"
        path="resources"
        leftNav={false}
        component={AssignmentResources}
      />
      <Route
        name="results-summary"
        path="students"
        leftNav={false}
        component={StudentPerformanceOverview}
      />
      <Route
        name="results-summary"
        path="questions"
        leftNav={false}
        component={QuestionsTable}
      />
      <Route
        name="ClassPerformanceItem"
        path="questions/:questionId"
        component={TeacherPerformanceItem}
        leftNav={false}
      />
      <Route
        name="ClassPerformanceItemPart"
        path="questions/:questionId/parts/:partId"
        component={TeacherPerformanceItem}
        leftNav={false}
      />
    </Route>

    <Route
      name="student-results"
      path="students/:studentId"
      leftNav={false}
      component={TeacherStudentResultsContainer}
    >
      <IndexRedirect to="resources" />
      <Route
        name="TeacherStudentResponses"
        path="responses"
        leftNav={false}
        component={TeacherStudentResponses}
      >
        <Route
          name="StudentRubricsQuestions"
          path="questions/:questionId(/parts/:partId)"
          leftNav={false}
          component={ScoringLayout}
        />
      </Route>
      <Route
        name="SingleStudentPerformanceOverview"
        path="questions"
        leftNav={false}
        component={SingleStudentPerformanceOverview}
      />
      <Route
        name="SingleStudentQuestions"
        path="parts/:ppcPartId"
        leftNav={false}
        component={SingleStudentQuestions}
      >
        <IndexRoute
          name="SingleStudentPartOverview"
          leftNav={false}
          component={SingleStudentPerformanceOverview}
        />
        <Route
          name="SingleStudentPerformanceItemOption"
          leftNav={false}
          path="performance/:questionId"
          component={StudentPerformanceItem}
        />
        <Route name="submissionResultsView" leftNav={false} path="review" />
      </Route>
      <Route
        name="SingleStudentPerformanceItem"
        path="questions/:questionId"
        component={StudentPerformanceItem}
        leftNav={false}
      >
        <Route
          name="SingleStudentPerformanceItemOption"
          path="parts/:partId"
          component={StudentPerformanceItem}
          leftNav={false}
        />
        <Route name="submissionResultsView" path="review" leftNav={false} />
      </Route>

      <Route
        name="SingleStudentResources"
        path="resources"
        leftNav={false}
        component={SingleStudentResources}
      />
      <Route
        name="csperformance-summary"
        path="csperformance"
        leftNav={false}
        component={AssignmentTrendReport}
      />
    </Route>
  </Route>
);
